import { productsService } from '@/services';

export const productsModule = {
  namespaced: true,
  state: () => ({
    list:{
      data: null,
      error: null,
    },
    listFilters: {},
    product:{
      data: null,
      error: null,
    },
    productByEan:{
      data: null,
      error: null,
    },
    newProduct:{
      data: null,
      error: null,
    },
    updateProduct:{
      data: null,
      error: null,
    },
    productsExcel:{
      data: null,
      error: null,
    },
    
  }),
  mutations: {
    load(state,request) {
      state.listFilters = { ...JSON.parse(JSON.stringify(request)) }
      productsService.getProducts(request.pagination,request.filters)
        .then((res) => {
          state.list.data = res
        })
        .catch((error) => {
          state.list.data = null
          state.list.error = error
        });      
    },
    getById(state, id) {
      productsService.getProductById(id)
        .then((res) => {
          state.product.data = res
        })
        .catch((error) => {
          state.product.data = null
          state.product.error = error
        });      
    },
    getByEan(state, ean) {
      productsService.getProductByEan(ean)
        .then((res) => {
          state.productByEan.data = res
        })
        .catch((error) => {
          state.productByEan.data = null
          state.productByEan.error = error
        });
    },
    newProduct(state, body){
      productsService.newProduct(body)
      .then((res) => {
        state.newProduct.data = res
      })
      .catch((error) => {
        state.newProduct.data = null
        state.newProduct.error = error
      }); 
    },
    updateProduct(state, body){
      productsService.updateProduct(body)
      .then((res) => {
        state.updateProduct.data = res
      })
      .catch((error) => {
        state.updateProduct.data = null
        state.updateProduct.error = error
      }); 
    },
    productsExcel(state, request) {
      productsService.getProductsAsExcel(request.filters, request.language)
      .then((excel) => {
        state.productsExcel.data = excel
      })
      .catch((error) => {
        state.productsExcel.data = null
        state.productsExcel.error = error
      });
    }
  }
}